import type { AxiosError } from 'axios';

/**
 * The registration endpoints answer duplicated users with a plain string body (409)
 * and validation failures with a { Message } payload (400).
 */
export const toRegistrationErrorMessage = (error: AxiosError): string => {
    const data = error.response?.data;

    if (typeof data === 'string' && data.length) return data;
    if (data?.Message) return data.Message;

    window.rumReportError(error);
    return 'Error creating your account';
};
